(() => {
  const script = document.currentScript;
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width: 749px)');
  const state = { rewards: null, chat: null, rewardsOpen: false, chatOpen: false, returnFocus: null };
  const observedRoots = new WeakSet();
  let queued = false;
  const controls = (type) => [...document.querySelectorAll(`[data-th-widget="${type}"]`)];
  const visible = (element) => element?.isConnected && element.getClientRects().length > 0;
  const restoreFocus = () => {
    const target = state.returnFocus;
    state.returnFocus = null;
    if (visible(target)) requestAnimationFrame(() => target.focus({ preventScroll: true }));
  };
  const findRewards = () => document.querySelector('#honeypop-app > button');
  const findChat = () => {
    const host = document.querySelector('shopify-chat');
    const hostRoot = host?.shadowRoot;
    const runtime = hostRoot?.querySelector('shopify-agent-runtime');
    watchRoot(hostRoot);
    watchRoot(runtime?.shadowRoot);
    return runtime?.shadowRoot?.querySelector('button[part~="activator"]') || hostRoot?.querySelector('button[part~="activator"]');
  };
  const updateReady = (type, launcher) => {
    const buttons = controls(type);
    const ready = Boolean(launcher && buttons.length);
    root.classList.toggle(`th-mobile-${type}-ready`, ready);
    for (const button of buttons) button.hidden = !ready;
    if (type === 'rewards' && launcher) launcher.setAttribute('data-th-rewards-launcher', '');
    state[type] = launcher;
  };
  const refresh = () => {
    queued = false;
    updateReady('rewards', findRewards());
    updateReady('chat', findChat());
    const close = document.querySelector('#honeypop-app [data-honeypop-close]');
    const rewardsOpen = Boolean(close);
    if (close && mobile.matches) {
      close.setAttribute('aria-label', script?.dataset.closeRewards || 'Close rewards');
      const panel = close.closest('#honeypop-app > div');
      if (panel) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-label', script?.dataset.rewardsTitle || 'Rewards');
      }
      if (!state.rewardsOpen && state.returnFocus) requestAnimationFrame(() => close.focus());
    }
    for (const button of controls('rewards')) button.setAttribute('aria-expanded', String(rewardsOpen));
    const chatOpen = state.chat?.getAttribute('aria-expanded') === 'true';
    for (const button of controls('chat')) button.setAttribute('aria-expanded', String(chatOpen));
    if ((state.rewardsOpen && !rewardsOpen) || (state.chatOpen && !chatOpen)) restoreFocus();
    state.rewardsOpen = rewardsOpen;
    state.chatOpen = chatOpen;
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  };
  function watchRoot(target) {
    if (!target || observedRoots.has(target)) return;
    observedRoots.add(target);
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-th-widget]');
    if (!trigger) return;
    const type = trigger.dataset.thWidget;
    const launcher = type === 'rewards' ? findRewards() : findChat();
    if (!launcher) { schedule(); return; }
    const drawer = trigger.closest('details.th-mobile-nav');
    state.returnFocus = drawer?.querySelector('summary') || trigger;
    if (drawer) drawer.open = false;
    if (type === 'chat' && launcher.getAttribute('aria-expanded') === 'true') return;
    // The public host method tracks the initiating gesture and native shell state.
    // Clicking its internal shadow button directly can be undone by the host.
    const chat = type === 'chat' ? document.querySelector('shopify-chat') : null;
    if (chat && typeof chat.show === 'function') chat.show();
    else launcher.click();
    schedule();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !mobile.matches || !state.rewardsOpen) return;
    const close = document.querySelector('#honeypop-app [data-honeypop-close]');
    if (close) { close.click(); schedule(); }
  });
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  if (window.customElements) {
    customElements.whenDefined('shopify-chat').then(schedule);
    customElements.whenDefined('shopify-agent-runtime').then(schedule);
  }
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  refresh();
})();
